<template>
  <v-container fluid mx-0 pa-0>
    <v-row no-gutters>
      <About/>
    </v-row>
    <v-row no-gutters>
      <Services/>
    </v-row>
    <v-row no-gutters class="geo-global">
      <Global/>
      <v-spacer style="height: 300px; width: 100%"/>
      <Geo/>
    </v-row>
    <v-row no-gutters>
      <Contacts/>
    </v-row>
  </v-container>
</template>

<script>
  import About from '../components/About'
  import Services from '../components/Services'
  import Contacts from '../components/Contacts'
  import Global from '../components/Global'
  import Geo from '../components/Geo'

  export default {
    name: 'home',
    components: { Geo, Global, Contacts, Services, About }
  }
</script>

<style scoped>
  .geo-global {
    background: #24659F url('../assets/geo.png') no-repeat center center;
    background-size: cover;
    height: 2400px;
  }
</style>
